module.exports = __webpack_public_path__ + "static/media/main-banner.89550ce8.jpg";